module.exports = __webpack_public_path__ + "static/media/warning_icon.ea685012.svg";